var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "transfer__wrapper" }, [
    _c("div", { staticClass: "container-header" }, [
      _c("div", { staticClass: "container-header__title" }, [
        _vm._v(
          _vm._s(
            _vm.form.convert ? _vm.i18n.lbl_exchange() : _vm.i18n.lbl_send()
          )
        )
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "transfer md-layout md-alignment-center-center" },
      [
        !_vm.tokenCodes.length
          ? [
              _c(
                "div",
                { staticClass: "container__no-data" },
                [
                  _c(
                    "md-card",
                    {
                      staticClass:
                        "container container_40 md-layout-item md-size-100"
                    },
                    [
                      _c("md-icon", { staticClass: "md-size-4x" }, [
                        _vm._v("send")
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "text_large" }, [
                        _vm._v(_vm._s(_vm.i18n.tr_no_assets()))
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "text_description text_margin text_medium"
                        },
                        [_vm._v(_vm._s(_vm.i18n.tr_no_assets_exp()))]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ]
          : _vm.view.mode === _vm.VIEW_MODES.submit
          ? [
              _c(
                "form",
                {
                  staticClass:
                    "md-layout-item md-size-50 md-medium-size-65 md-small-size-95 md-xsmall-size-100",
                  attrs: { novalidate: "" },
                  on: {
                    submit: function($event) {
                      $event.preventDefault()
                      return _vm.processTransfer(true)
                    }
                  }
                },
                [
                  _c(
                    "md-card",
                    { staticClass: "container container_40" },
                    [
                      _vm.isPending
                        ? _c("md-progress-bar", {
                            attrs: { "md-mode": "indeterminate" }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "transfer__user-balance text_medium" },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.i18n.tr_balance({
                                  balance: _vm.swimBalance,
                                  token: _vm.assetIcon(_vm.form.tokenCode)
                                })
                              ) +
                              "\n          "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        [
                          _c("div", { staticClass: "md-layout md-gutter" }, [
                            _vm.form.convert
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "md-layout-item md-small-size-100"
                                  },
                                  [
                                    _c("input-field", {
                                      attrs: {
                                        id: "transfer-token",
                                        name: "token",
                                        type: "text",
                                        "data-vv-as": _vm.i18n.lbl_asset(),
                                        label: _vm.i18n.lbl_asset(),
                                        readonly: true
                                      },
                                      on: { change: _vm.tryGetFees },
                                      model: {
                                        value: _vm.form.tokenCode,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "tokenCode", $$v)
                                        },
                                        expression: "form.tokenCode"
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _c(
                                  "div",
                                  {
                                    staticClass:
                                      "md-layout-item md-small-size-100"
                                  },
                                  [
                                    _c("select-field", {
                                      attrs: {
                                        id: "transfer-token",
                                        name: "token",
                                        label: _vm.i18n.lbl_choose_asset(),
                                        values: _vm.tokenCodes
                                      },
                                      on: {
                                        change: function($event) {
                                          _vm.checkLimits(), _vm.tryGetFees()
                                        }
                                      },
                                      model: {
                                        value: _vm.form.tokenCode,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "tokenCode", $$v)
                                        },
                                        expression: "form.tokenCode"
                                      }
                                    })
                                  ],
                                  1
                                ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "md-layout-item md-small-size-100 transfer__amount"
                              },
                              [
                                _c("input-field", {
                                  directives: [
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: "required|amount",
                                      expression: "'required|amount'"
                                    }
                                  ],
                                  staticClass: "field__number",
                                  attrs: {
                                    id: "transfer-amount",
                                    name: "amount",
                                    type: "number",
                                    "data-vv-as": _vm.i18n.lbl_amount(),
                                    label: _vm.i18n.lbl_amount(),
                                    readonly: _vm.form.convert,
                                    errorMessage:
                                      _vm.errorMessage("amount") ||
                                      (_vm.isBalanceExceeded
                                        ? _vm.i18n.withdraw_error_insufficient_funds()
                                        : "")
                                  },
                                  on: { blur: _vm.checkAmount },
                                  model: {
                                    value: _vm.form.amount,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "amount", $$v)
                                    },
                                    expression: "form.amount"
                                  }
                                })
                              ],
                              1
                            )
                          ]),
                          _vm._v(" "),
                          !_vm.form.convert
                            ? _c("div", [
                                _vm._v(
                                  _vm._s(
                                    _vm.allFeesLoaded
                                      ? _vm.i18n.fees_percent_fixed({
                                          percent: _vm.allFees.percent,
                                          fixed: _vm.allFees.fixed,
                                          currency: _vm.assetIcon(
                                            _vm.form.tokenCode
                                          )
                                        })
                                      : ""
                                  )
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.form.convert
                            ? _c("input-field", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required|email_or_account_id",
                                    expression: "'required|email_or_account_id'"
                                  }
                                ],
                                attrs: {
                                  id: "transfer-recipient",
                                  name: "recipient",
                                  label: _vm.i18n.lbl_recipient_email_or_account(),
                                  readonly: _vm.form.convert,
                                  errorMessage: _vm.errorMessage("recipient")
                                },
                                model: {
                                  value: _vm.form.recipient,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "recipient", $$v)
                                  },
                                  expression: "form.recipient"
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.limitsList
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "transfer__limits-container text_small",
                                  class: { loading: _vm.isFeesLoadPending }
                                },
                                [
                                  _vm._l(_vm.limitsList, function(item, key) {
                                    return [
                                      item.period === "operation" ||
                                      item.period === "day"
                                        ? _c(
                                            "div",
                                            {
                                              key: key,
                                              class: {
                                                "limits-operational":
                                                  item.period === "operation"
                                              }
                                            },
                                            [
                                              _c("p"),
                                              _vm._v(" "),
                                              item.period === "operation"
                                                ? _c("p", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.i18n.lim_withdrawal_daily_msg1(
                                                          {
                                                            limit:
                                                              item.amount_limit,
                                                            asset:
                                                              _vm.form.tokenCode
                                                          }
                                                        )
                                                      )
                                                    )
                                                  ])
                                                : _vm._e(),
                                              _vm._v(" "),
                                              item.period === "day"
                                                ? _c("p", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.i18n.lim_withdrawal_daily_msg2(
                                                          {
                                                            limit:
                                                              item.amount_limit,
                                                            asset:
                                                              _vm.form.tokenCode
                                                          }
                                                        )
                                                      )
                                                    )
                                                  ])
                                                : _vm._e(),
                                              _vm._v(" "),
                                              key === 0
                                                ? _c("p", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.i18n.lim_withdrawal_daily_msg3()
                                                      )
                                                    )
                                                  ])
                                                : _vm._e()
                                            ]
                                          )
                                        : _vm._e()
                                    ]
                                  })
                                ],
                                2
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.form.convert
                            ? _c("textarea-field", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "max:250",
                                    expression: "'max:250'"
                                  }
                                ],
                                attrs: {
                                  id: "transfer-description",
                                  name: "description",
                                  label: _vm.i18n.lbl_add_note(),
                                  disabled: _vm.form.convert,
                                  maxlength: 250,
                                  errorMessage: _vm.errorMessage("recipient")
                                },
                                model: {
                                  value: _vm.form.subject,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "subject", $$v)
                                  },
                                  expression: "form.subject"
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "btn-wrap" },
                        [
                          _vm.form.convert
                            ? [
                                _c(
                                  "md-button",
                                  {
                                    staticClass:
                                      "btn md-primary md-yellow w-100",
                                    attrs: {
                                      type: "submit",
                                      disabled: _vm.isPending
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.processTransfer()
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(_vm.i18n.lbl_exchange()) +
                                        "\n              "
                                    )
                                  ]
                                )
                              ]
                            : [
                                _c(
                                  "md-button",
                                  {
                                    staticClass:
                                      "btn md-primary md-yellow w-100",
                                    attrs: {
                                      type: "submit",
                                      disabled:
                                        _vm.isBalanceExceeded || _vm.isPending
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(_vm.i18n.lbl_send()) +
                                        "\n              "
                                    )
                                  ]
                                )
                              ]
                        ],
                        2
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ]
          : _vm.view.mode === _vm.VIEW_MODES.confirm
          ? [
              _c("confirm-transfer", {
                staticClass:
                  "md-layout-item md-size-50 md-medium-size-65 md-small-size-100 md-xsmall-size-100",
                attrs: {
                  opts: _vm.view.opts,
                  limitsList: _vm.limitsList,
                  isPending: _vm.isPending
                },
                on: {
                  "cancel-click": function($event) {
                    return _vm.updateView(_vm.VIEW_MODES.submit)
                  },
                  "confirm-click": _vm.submit
                }
              })
            ]
          : _vm._e(),
        _vm._v(" "),
        _vm.view.mode === _vm.VIEW_MODES.success
          ? [
              _c(
                "md-card",
                {
                  staticClass:
                    "transfer__success-msg container container_30 md-layout-item md-size-50 md-medium-size-45 md-small-size-100 md-xsmall-size-100"
                },
                [
                  _c("md-card-header", [
                    _c("div", { staticClass: "md-title" }, [
                      _vm._v(_vm._s(_vm.i18n.tr_successful()))
                    ])
                  ]),
                  _vm._v(" "),
                  _c("md-card-content", [
                    _c("div", [
                      _c(
                        "div",
                        { staticClass: "transfer__success-amount text_medium" },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.swimAmount) +
                              " " +
                              _vm._s(_vm.form.tokenCode) +
                              "\n            "
                          )
                        ]
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "btn-wrap" },
                    [
                      _c(
                        "md-button",
                        {
                          staticClass: "btn md-primary",
                          on: {
                            click: function($event) {
                              _vm.form.convert
                                ? _vm.goExchange()
                                : _vm.updateView(
                                    _vm.VIEW_MODES.submit,
                                    {},
                                    true
                                  )
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.i18n.lbl_go_back()) +
                              "\n            "
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ]
          : _vm._e()
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3018c664", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3018c664","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/app/transfers/make/Transfers.Make.vue
// module id = Ng6s
// module chunks = 1